import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../shared/http-client-service';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../config/config.service';


@Injectable({
  providedIn: 'root'
})
export class SelectWorkLocationService {

 constructor(private httpClient: HttpClientService, config: ConfigService) {
        this.httpClient = httpClient;        
    }

  isWorkLocationAssignedToUser(userId) {
    return this.httpClient.get('api/WorkLocationQuery/IsWorkLocationAssigned/' + userId).pipe(map(responsedata => {
      let body = responsedata;
      return body;
    }));
  }

  getMatchingWorkLocations(searchText: string): any {
    return this.httpClient.get('api/WorkLocationQuery/searchWorkLocations/' + searchText).pipe(map(responsedata => {
      let body = responsedata;
      return body;
    }));
  }
  
  isWorkLocationAlreadyAssigned(locationId: any) {
    return this.httpClient.get('api/WorkLocationQuery/isWorkLocationLocked/'+ locationId).pipe(map(responsedata => {
      let body = responsedata;
      return body;
    }));
  }

  lockWorkLocation(data: any) {
    return this.httpClient.post('api/WorkLocation/lockWorkLocation', JSON.stringify(data)).pipe(map(responsedata => {
      if (responsedata.status < 200 || responsedata.status >= 300) {
        throw new Error('This request has failed ' + responsedata.status);
      } else {
        return responsedata;
      }
    }));
  }
}
